import React from 'react';
import { Table, Button, Input, InputNumber, Space, Typography, message, Popconfirm } from 'antd';
import {
    listVideoCategories,
    createVideoCategory,
    updateVideoCategory,
    deleteVideoCategory,
} from '../../api/video';

class VideoCategoryManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            loading: false,
            newCatName: '',
            newCatSort: 0,
        };
    }

    componentDidMount() {
        if (this.props.open) {
            this.loadCategories();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            this.loadCategories();
        }
    }

    loadCategories = async () => {
        this.setState({ loading: true });
        try {
            const list = await listVideoCategories();
            this.setState({ categories: list });
        } catch (e) {
            message.error(e.message || '加载分类失败');
        } finally {
            this.setState({ loading: false });
        }
    };

    notifyChanged = () => {
        const { onChanged } = this.props;
        if (typeof onChanged === 'function') {
            onChanged();
        }
    };

    handleCreateCategory = async () => {
        const name = this.state.newCatName.trim();
        if (!name) {
            message.warning('请输入分类名称');
            return;
        }
        try {
            await createVideoCategory({
                categoryName: name,
                sortOrder: this.state.newCatSort,
            });
            message.success('分类已创建');
            this.setState({ newCatName: '', newCatSort: 0 });
            await this.loadCategories();
            this.notifyChanged();
        } catch (e) {
            message.error(e.message || '创建失败');
        }
    };

    handleUpdateCategory = async (record, field, value) => {
        try {
            await updateVideoCategory(record.id, {
                categoryName: field === 'categoryName' ? value : record.categoryName,
                sortOrder: field === 'sortOrder' ? value : record.sortOrder,
            });
            await this.loadCategories();
            this.notifyChanged();
        } catch (e) {
            message.error(e.message || '更新失败');
        }
    };

    handleDeleteCategory = async (id) => {
        try {
            await deleteVideoCategory(id);
            message.success('分类已删除');
            await this.loadCategories();
            this.notifyChanged();
        } catch (e) {
            message.error(e.message || '删除失败');
        }
    };

    render() {
        const { categories, loading, newCatName, newCatSort } = this.state;

        return (
            <>
                <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
                    每个视频只能属于一个分类，用于归类（如「电影」「纪录片」）。
                </Typography.Paragraph>
                <Space.Compact style={{ width: '100%', marginBottom: 16 }}>
                    <Input
                        placeholder="新分类名称"
                        value={newCatName}
                        onChange={(e) => this.setState({ newCatName: e.target.value })}
                        onPressEnter={this.handleCreateCategory}
                    />
                    <InputNumber
                        placeholder="排序"
                        value={newCatSort}
                        onChange={(v) => this.setState({ newCatSort: v ?? 0 })}
                        style={{ width: 100 }}
                    />
                    <Button type="primary" onClick={this.handleCreateCategory}>
                        添加
                    </Button>
                </Space.Compact>
                <Table
                    size="small"
                    rowKey="id"
                    loading={loading}
                    scroll={{ x: 'max-content' }}
                    dataSource={categories}
                    pagination={false}
                    columns={[
                        { title: 'ID', dataIndex: 'id', width: 60 },
                        {
                            title: '名称',
                            dataIndex: 'categoryName',
                            render: (v, row) => (
                                <Input
                                    defaultValue={v}
                                    size="small"
                                    onBlur={(e) => {
                                        const next = e.target.value.trim();
                                        if (next && next !== v) {
                                            this.handleUpdateCategory(row, 'categoryName', next);
                                        }
                                    }}
                                />
                            ),
                        },
                        {
                            title: '排序',
                            dataIndex: 'sortOrder',
                            width: 100,
                            render: (v, row) => (
                                <InputNumber
                                    size="small"
                                    defaultValue={v ?? 0}
                                    onBlur={(e) => {
                                        const next = Number(e.target.value);
                                        if (!Number.isNaN(next) && next !== v) {
                                            this.handleUpdateCategory(row, 'sortOrder', next);
                                        }
                                    }}
                                />
                            ),
                        },
                        {
                            title: '操作',
                            width: 80,
                            render: (_, row) => (
                                <Popconfirm
                                    title="确认删除该分类？"
                                    description="仅当无关联视频时可删除"
                                    onConfirm={() => this.handleDeleteCategory(row.id)}
                                >
                                    <Button type="link" size="small" danger>
                                        删除
                                    </Button>
                                </Popconfirm>
                            ),
                        },
                    ]}
                />
            </>
        );
    }
}

export default VideoCategoryManager;
